import { useEffect, useState } from 'react'
import { ConfigProvider, Empty } from 'antd'
import { theme } from 'src/theme/antd-theme'
import { antdLocales } from 'src/locales/antd-locales'
import { getDateFormatByLocale } from 'src/utils/format-date'
import { useTranslation } from 'react-i18next'

type Props = {
  children: React.ReactNode
}

export const AntdProvider = ({ children }: Props) => {
  const { i18n } = useTranslation()
  const savedLanguage = localStorage.getItem('i18nextLng')
  const [locale, setLocale] = useState(() => {
    return (
      antdLocales[savedLanguage as keyof typeof antdLocales] ||
      antdLocales['en-US']
    )
  })

  useEffect(() => {
    const handleLanguageChange = () => {
      const savedLanguage = localStorage.getItem('i18nextLng')
      if (
        savedLanguage &&
        antdLocales[savedLanguage as keyof typeof antdLocales]
      ) {
        setLocale(antdLocales[savedLanguage as keyof typeof antdLocales])
      }
    }

    handleLanguageChange()
  }, [i18n.language])

  const globalBuddhistLocale: typeof locale = {
    ...locale,
    DatePicker: {
      ...locale.DatePicker!,
      lang: {
        ...locale!.DatePicker!.lang,
        fieldDateFormat: getDateFormatByLocale(savedLanguage ?? 'en-US'),
      },
    },
  }

  return (
    <ConfigProvider
      locale={globalBuddhistLocale}
      theme={theme}
      renderEmpty={(e) => {
        if (e === 'Table') {
          return <Empty />
        }

        if (e === 'Select') {
          return <></>
        }

        return <Empty />
      }}
    >
      {children}
    </ConfigProvider>
  )
}
